import React, { useState, useEffect, Link } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Cookies } from '../../index.js';
import { Helmet } from "react-helmet";
import Iframe from 'react-iframe';
import Select from "react-select";
import AdSense from "react-adsense";
import { alert_error, alert_success } from '../../AppContext';
function Convert() {
    const [nutxuly, setnutxuly] = useState(0);
    const [inputlienket, setinputlienket] = useState('');
    const [nutorder, setnutorder] = useState("✔️ Click to Confirm");
    const [apikey, setapikey] = useState('');
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutxuly(0);
        if (info != '') {
            if (status == 1) {
                alert_success(message);
                setnutorder('Cảm ơn bạn đã ủng hộ');
            }
            else if (status == 0) {
                setnutorder(message);
                alert_error(message);
            }
            else {
                setnutorder('Đã xảy ra lỗi vui lòng nhập lại');
                alert_error('Đã xảy ra lỗi vui lòng nhập lại');
            }
        }
        else {
            setnutorder('xác nhận');
            alert_error('Không tìm thấy dữ liệu');
        }
        if (info.redirect != null && info.redirect != "") {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    function handleSubmit(event) {
        const myCookieValue = Cookies.get('apikey');
        event.preventDefault();
        setnutxuly(1);
        setnutorder('Please wait a moment 😊');
        if (!inputlienket) {
            setnutorder('xác nhận');
            alert_error('Please điền đầy đủ thông tin')
            setnutxuly(0);
            return
        }
        else {
            axios
                .post("https://hust.media/jop/tiktok/converttiktok.php", {
                    key: myCookieValue,
                    fullname: inputlienket
                })
                .then((response) => testFunction(response))
                .catch((error) => alert_error(error));
        }

    }
    useEffect(() => {
        const myCookieValue = Cookies.get('apikey');
        setapikey(myCookieValue);
    }, []);
    return (
        <>
            <form className=" mt-3  mx-2 mx-auto max-w-xl add-form">
                <div className="mb-2 form-control">
                    <div id="M882924ScriptRootC1520508"></div>
                    <Helmet>
                        <script src="https://jsc.adskeeper.com/h/u/hust.media.1520508.js" async></script>
                    </Helmet>
                    <div className="mt-1 text-xslg:text-base">
                        <label
                            htmlFor="pin-input"
                            className="inline-block font-bold mb-1"
                        >
                            <div className="mt-2 mb-2 mx-2 inline-block text-gray-500 ">
                                Bạn điền id hoặc liên kết kênh tiktok của bạn nhé
                            </div>
                        </label>
                        <div className="input-group flex-nowrap">
                            <span className="input-group-text" id="addon-wrapping">
                                @
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nhập link hoặc id tiktok"
                                aria-label="inputlienket"
                                value={inputlienket}
                                name="inputlienket"
                                aria-describedby="addon-wrapping"
                                onChange={(e) => setinputlienket(e.target.value)}
                            />
                        </div>

                    </div>
                    <button disabled={nutxuly == 1}
                        onClick={handleSubmit}
                        className="my-3 mb-2 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-0 w-full dark:bg-slate-800 dark:text-white"
                    >
                        <div className="flex items-center justify-between flex-1">
                            {nutxuly == 1 && (
                                <div className="spinner-border" role="status"></div>
                            )}

                            <span className="text-lg font-medium text-white">
                                {nutorder}{" "}
                            </span>
                            <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                        </div>
                    </button>

                    <div className="mt-3 text-center">
                        <a href={`/shop/orders/media?key=${apikey}`}>
                            <div className="mx-2 btn btn-primary">
                                Tạo jop tiktok
                            </div>
                        </a>
                        <a target="_blank" href="https://t.me/dangbaiok">
                            <div className="mx-2 btn btn-primary">
                                Hướng dẫn
                            </div>
                        </a>
                        <button className="mx-2 btn btn-primary"
                            onClick={() => switch_router('/shop/jop/cheotiktok?showadview=true')}
                        >
                            Chéo
                        </button>
                    </div>
                </div>
            </form>
            <div className="mx-2">
                <div className="max-w-xs mx-2 mx-auto">
                    <div className="cards">
                        <AdSense.Google
                            client="ca-pub-4574266110812955"
                            slot="3259681051"
                            style={{ display: 'block' }}
                            format="auto"
                            responsive="true"
                        />
                    </div> </div>
            </div>
        </>)
}

export default Convert;